//@ts-check
import { toast } from 'react-toastify';
import 'util';
import { t } from 'i18next';

export class ApiHelper {
    getData = (url, onSuccess, onFailure, signal) => {
        var fetchResponse = fetch(url, { signal })
            .then(this.handleResponseStatus)
            .then((response) => response.json())
            .then((data) => this.handleCallback(data, onSuccess))
            .catch((error) => this.handleError(error, url, onFailure));

        return fetchResponse;
    };

    getPagedData = (url, pagingOptions, onSuccess, onFailure) => {
        let pagingHeaders = {
            'X-App-Paging-PageIndex': pagingOptions.pageIndex.toString(),
            'X-App-Paging-PageSize': pagingOptions.pageSize.toString()
        };

        var getOptions = {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            headers: pagingHeaders
        };

        var fetchResponse = fetch(url, getOptions)
            .then(this.handleResponseStatus)
            .then((response) => response.json())
            .then((data) => this.handleCallback(data, onSuccess))
            .catch((error) => this.handleError(error, url, onFailure));

        return fetchResponse;
    };

    getDataSecure = (url, token, onSuccess, onFailure) => {
        const getOptions = {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        const fetchResponse = fetch(url, getOptions)
            .then(this.handleResponseStatus)
            .then((response) => response.json())
            .then((data) => this.handleCallback(data, onSuccess))
            .catch((error) => this.handleError(error, url, onFailure));

        return fetchResponse;
    };

    getDataSecureAsync = async (url, token, onSuccess, onFailure, signal) => {
        const getOptions = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        const fetchResponse = await fetch(url, getOptions, { signal: signal })
            .then(this.handleResponseStatus)
            .then((response) => response.json())
            .then((data) => this.handleCallback(data, onSuccess))
            .catch((error) => this.handleError(error, url, onFailure));

        return fetchResponse;
    };

    postData = (url, data, onSuccess, onFailure) => {
        var postOptions = {
            method: 'POST',
            mode: 'same-origin',
            cache: 'no-cache',
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(data)
        };

        var postResponse = fetch(url, postOptions)
            .then(this.handleResponseStatus)
            .then(function (response) {
                if (response.bodyUsed) {
                    response.json();
                }
            })
            .then((data) => this.handleCallback(data, onSuccess))
            .catch((error) => this.handleError(error, url, onFailure));

        return postResponse;
    };

    postDataSecure = (url, data, token, onSuccess, onFailure) => {
        var postOptions = {
            method: 'POST',
            mode: 'same-origin',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        };

        var postResponse = fetch(url, postOptions)
            .then(this.handleResponseStatus)
            .then(function (response) {
                if (response.bodyUsed) {
                    response.json();
                }
            })
            .then((data) => this.handleCallback(data, onSuccess))
            .catch((error) => this.handleError(error, url, onFailure));

        return postResponse;
    };

    postDataWithResponse(url, data, onSuccess, onFailure) {
        var postOptions = {
            method: 'POST',
            mode: 'same-origin',
            cache: 'no-cache',
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
            body: JSON.stringify(data)
        };

        console.log('postDataWithResponse ...');

        var postResponse = fetch(url, postOptions)
            .then(this.handleResponseStatus)
            .then((response) => response.json())
            .then((data) => this.handleCallback(data, onSuccess))
            .catch((error) => this.handleError(error, url, onFailure));

        return postResponse;
    }

    postDataWithResponseSecure(
        url,
        data,
        token,
        onSuccess,
        onFailure,
        signal,
        options = { skipToastNotification: false }
    ) {
        var postOptions = {
            method: 'POST',
            mode: 'same-origin',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
        };

        console.log('postDataWithResponse ...');

        var postResponse = fetch(url, postOptions, { signal: signal })
            .then(this.handleResponseStatus)
            .then((response) => response.json())
            .then((data) => this.handleCallback(data, onSuccess))
            .catch((error) => this.handleError(error, url, onFailure, options));

        return postResponse;
    }

    deleteData(url, data, callback) {
        // Default options are marked with *
        var deleteOptions = {
            method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
            mode: 'same-origin', // no-cors, cors, *same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
            body: data // body data type must match "Content-Type" header
        };

        var deleteResponse = fetch(url, deleteOptions)
            .then((response) => {
                if (callback !== null) {
                    callback(response);
                }
            })
            .catch((error) => console.log('Error:' + error));

        return deleteResponse;
    }

    handleResponseStatus(response) {
        if (!response.ok) {
            console.log(`status: ${response.statusText}`);
            throw new Error(response.statusText);
        }
        return response;
    }

    handleError(error, url, callback, { skipToastNotification } = {}) {
        console.log('Fetch URL: ' + url);
        console.error(error);

        if (!skipToastNotification)
            toast.error(t('error_messages.api_default'));

        this.handleCallback(error, callback);
    }

    handleCallback(data, callback) {
        if (callback != null) {
            callback(data);
        }
    }
}
